import { Link } from "react-router-dom";
import Logo from "./Logo";

const LINKS = [
  { label: "FAQs", to: "/faqs" },
  { label: "Shop", to: "/shop" },
  { label: "Contact Vibe", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-[#F4FAF6] border-t border-[#D1E2D6]" data-testid="site-footer">
      <div className="mx-auto max-w-[88rem] px-5 sm:px-10 py-14 lg:py-16">
        <div className="flex flex-col lg:flex-row items-center lg:items-center justify-between gap-10">
          <div className="flex flex-col items-center lg:items-start gap-3">
            <Logo />
            <p className="text-sm text-[#4A6B56]">A little ritual. A fresh perspective.</p>
          </div>

          <nav
            className="flex flex-wrap items-center justify-center gap-x-9 gap-y-3"
            data-testid="footer-links"
          >
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.to.replace("/", "")}`}
                className="link-underline text-[#4A6B56] hover:text-[#1B4332] transition-colors duration-300 whitespace-nowrap"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex flex-col items-center lg:items-end gap-2 lg:max-w-xs lg:text-right">
            <p className="text-sm text-[#4A6B56]">
              Questions? Write to{" "}
              <a
                href="mailto:helpdesk@getvibe.co.in"
                data-testid="footer-email-link"
                className="underline underline-offset-4 text-[#1B4332]"
              >
                helpdesk@getvibe.co.in
              </a>
            </p>
            <p className="text-xs text-[#4A6B56]">
              © 2026 Vibe. All rights reserved. Product information is not medical advice. Seek
              professional advice before use.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
